export default "__VITE_ASSET__DPhi_eT9__"